import { fetchHeaderFooterHomeData } from "../../lib/serverFetch";
import { getWorkshopPageDataAction, fetchWorkshopActivities } from "../../lib/actions/workshopAction";
import WorkshopPageClient from "../../components/workshops/WorkshopPageClient";
import { extractLanguage } from "../../lib/utils/domain";

export const dynamic = "force-dynamic";

export default async function WorkshopPages() {
  const headerFooterHomeData = await fetchHeaderFooterHomeData();

  // Fetch workshop page content from API (automatically handles franchiseeId and lang)
  const workshopPageDataResponse = await getWorkshopPageDataAction();

  const workshopPageData =
    workshopPageDataResponse.success && workshopPageDataResponse.data
      ? workshopPageDataResponse.data
      : { default: null, translated: null };

  return (
    <WorkshopPageClient
      headerFooterHomeData={headerFooterHomeData}
      workshopPageData={workshopPageData}
    />
  );
}